module.exports = __webpack_public_path__ + "static/demo-screen-6-6dbcb7b7a928620cdea225e835c51635.jpg";